import { Box, Modal, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

interface ImagePreviewProps {
    imageSrc: any,
    setOpen: any,
    open: any
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 450,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '8px',
    overflow: 'hidden'

};

const ImagePreview = ({ imageSrc, setOpen, open }: ImagePreviewProps) => {

    if (!open) {
        return null
    }

    const handleClose = () => setOpen(false);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} >
                <Box sx={{ background: '#3150A1', padding: '8px 12px', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography style={{ color: 'white' }}>Document</Typography>
                    <CloseIcon onClick={() => handleClose()} style={{ cursor: 'pointer', color: 'red' }} />
                </Box>

                <img src={imageSrc} alt="Document" width="560" height='450' style={{ width: '100%', height: '100%', objectFit: 'fill' }} />

            </Box>
        </Modal>
    )
}

export default ImagePreview